import Submissions from './Submissions';

export default function AIApproved() {
  return (
    <Submissions
      lockedStatus="ai_approved"
      title="AI Approved"
      emptyTitle="All Clear!"
      emptyMessage="No AI-approved submissions awaiting manual review"
    />
  );
}
